import * as React from 'react';
import './App.css';
// import { Nav } from './Nav';
import { Header } from './Header';
import { Projects } from './Projects';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import { cyan500 } from 'material-ui/styles/colors';

const ProjectsData = require('./ProjectsData.json');

export const WORK_REF = 'work';
export const HACKS_REF = 'hacks';
export const TALKS_REF = 'talks';
export const VOLUNTEER_REF = 'volunteer';

const muiTheme = getMuiTheme({
  'palette': {
    'primary1Color': cyan500
  }
});

class App extends React.Component {

  render() {
    return (
      <MuiThemeProvider muiTheme={getMuiTheme(muiTheme)}>
        <div className="App">
          <Header />
          <Projects
            projects={ProjectsData.projects}
            scrollRef={WORK_REF}
            title="Projects"
            blurb="I love working on side projects, this is some of the bigger work I've done"
            color="blue"
          />
          <Projects
            projects={ProjectsData.hacks}
            scrollRef={HACKS_REF}
            title="Hacks"
            blurb="Here are some of the shorter projects I've worked on"
            color="green"
          />
          <Projects
            projects={ProjectsData.talks}
            scrollRef={TALKS_REF}
            title="Talks"
            blurb="I love speaking at conferences and meetups! Here are some of the talks I've done"
            color="yellow"
          />
          <Projects
            projects={ProjectsData.volunteer}
            scrollRef={VOLUNTEER_REF}
            title="Volunteer"
            blurb="I am actively involved in my community, here aresome of the initiatives I lead"
            color="purple"
          />
        </div>
      </MuiThemeProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/App.tsx